export const contactSexOptions = {"M": 'Man', "F": "Vrouw", "X": "Anders"}
export type ContactSex = keyof typeof contactSexOptions
export const contactTypeOptions = {
  'Calculator': "Calculator",
  'Werkvoorbereider': "Werkvoorbereider",
  'Projectleider': "Projectleider",
  'Uitvoerder': "Uitvoerder",
  'Voorman': "Voorman",
  'Assistent uitvoerder': "Assistent uitvoerder",
  'Directeur': "Directeur",
  'Particulier': "Particulier",
}
export type ContactType = keyof typeof contactTypeOptions;

export class Contact {
  constructor(
    public readonly id: string,
    public readonly relationId: string|null,
    public readonly contact_status: number|null,
    public readonly alias: string|null,
    public readonly initials: string|null,
    public readonly first_name: string|null,
    public readonly middle_name: string|null,
    public readonly last_name: string|null,
    public readonly full_name: string|null,
    public readonly type: ContactType|null,
    public readonly sex: ContactSex|null,
    public readonly phone: string|null,
    public readonly email: string|null,
    public readonly office_phone: string|null,
    public readonly job_type: number|null,
    public readonly job_name: string|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): Contact{
    return new Contact(
      json['id'],
      json['relation_id'],
      json['contact_status'],
      json['alias'],
      json['initials'],
      json['first_name'],
      json['middle_name'],
      json['last_name'],
      json['full_name'],
      json['type'],
      json['sex'],
      json['phone'],
      json['email'],
      json['office_phone'],
      json['job_type'],
      json['job_name'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}